export const PdfInitialData = {
  payload: {
    name: "",
    redirect_type: "pdf",
  },
};
